import { t } from "i18next";
import { Athlete, AthleteMeasurement } from "../../interfaces/athlete";
import moment from 'moment';
import ReactECharts from 'echarts-for-react';
import chartsIcon from "../../assets/images/charts.svg";

interface AthleteBMChartProps {
    athlete: Athlete;
}

export function AthleteBMChart(props: AthleteBMChartProps) {
    const options = {
        xAxis: {
            type: 'category',
            data: props.athlete.measurement.map((m: AthleteMeasurement) => {
                return moment(m.measurement_date).format('DD/MM');
            })
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: '{value} %'
            }
        },
        series: [
            {
                data: props.athlete.measurement.map((m: AthleteMeasurement) => {
                    return m.bm;
                }),
                type: 'line',
                smooth: true,
                color: 'orange',
                label: {
                    show: true,
                    position: 'top',
                    formatter: '{c} %'
                }
            }
        ]
    }

    return (
        <div className="athlete-weight-chart-container chart-box">
            <h3 className="chart-title">
                <img src={ chartsIcon } alt={ t("Body Mass")} />
                { t("Body Mass") }
            </h3>
            <div className="chart-content">
                <ReactECharts option={ options } />
            </div>
        </div>
    );
}